<template>
  <div class="ele-body">
    <el-card shadow="never" v-loading="loading" body-style="padding-bottom: 0;">
      <el-row :gutter="15">
        <el-col :md="4" style="margin-bottom: 15px">
          <!-- 区域列表 -->
          <div class="org-tree-group">
            <el-tree
              ref="orgTree"
              :data="deptData"
              :props="{ label: 'name' }"
              :expand-on-click-node="true"
              node-key="id"
              :default-expanded-keys="dataIdArr"
              @node-click="chooseClass"
              highlight-current
            />
          </div>
        </el-col>
        <!--学生列表-->
        <el-col :md="20" style="margin-bottom: 15px">
          <!-- 搜索表单 -->
          <el-form :model="where" class="ele-form-search ele-table-tool-default" @keyup.enter.native="getDorData()" @submit.native.prevent>
            <el-row :gutter="10" style="margin-top: 8px">
              <el-col :md="8" :sm="12">
                <el-form-item label="日期选择:">
                  <el-date-picker
                    v-model="date"
                    type="daterange"
                    range-separator="-"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    size="medium"
                    format="yyyy 年 MM 月 dd 日"
                    value-format="yyyy-MM-dd"
                    :unlink-panels="true"
                /></el-form-item>
              </el-col>
              <el-col :md="16" :sm="12">
                <div class="ele-form-actions">
                  <el-button type="primary" @click="searchData" size="small" icon="el-icon-search" class="ele-btn-icon">查询</el-button>
                  <el-button type="primary" @click="exportData" size="small" icon="el-icon-download" class="ele-btn-icon">导出</el-button>
                </div>
              </el-col>
            </el-row>
          </el-form>
          <!-- 数据表格 -->
          <div style="font-size: 20px; text-align: center; margin: 10px auto; font-weight: bolder">总分值：{{ scoreTotal }}分</div>
          <ele-data-table ref="table" :data="dorData" height="calc(100vh - 261px)" highlight-current-row>
            <template #default="{ index }">
              <el-table-column type="selection" width="45" align="center" fixed="left" />
              <el-table-column type="index" :index="index" width="45" align="center" fixed="left" show-overflow-tooltip />
              <el-table-column prop="towerName" label="宿舍楼" show-overflow-tooltip />
              <el-table-column prop="storyName" label="楼层" show-overflow-tooltip />
              <el-table-column prop="roomName" label="宿舍号" show-overflow-tooltip />
              <el-table-column prop="score" label="分数" show-overflow-tooltip />
              <el-table-column label="操作" align="center">
                <template #default="{ row }">
                  <el-link @click="getDetail(row)" icon="el-icon-view" type="primary" :underline="false">明细</el-link>
                </template>
              </el-table-column>
            </template>
          </ele-data-table>
        </el-col>
      </el-row>
    </el-card>
    <el-dialog title="查看明细" :visible.sync="showDetail" width="50%">
      <ele-data-table ref="detailTable" :config="detailTable" height="calc(90vh - 300px)" highlight-current-row>
        <template #default="{ index }">
          <!--          <el-table-column type="index" :index="index" width="45" align="center" fixed="left" show-overflow-tooltip />-->
          <el-table-column prop="studentName" label="学生姓名" sortable="custom" show-overflow-tooltip />
          <el-table-column prop="itemName" label="指标名称" sortable="custom" show-overflow-tooltip />
          <el-table-column prop="itemValue" label="指标得分" sortable="custom" show-overflow-tooltip />
          <el-table-column prop="teacherName" label="考评教师" sortable="custom" show-overflow-tooltip />
          <el-table-column prop="assessTime" label="考评时间" sortable="custom" show-overflow-tooltip />
        </template>
      </ele-data-table>
    </el-dialog>
  </div>
</template>

<script>
  import { finiteDataTree, getDormitoryScoreList, dormitoryScoreExport } from '@/config/api';

  export default {
    name: 'Index',
    data() {
      return {
        loading: true, // 加载状态
        deptData: [], // 列表数据
        dataIdArr: [],
        date: null,
        aa: null,
        classId: null,
        dorData: [],
        scoreTotal: 0,
        where: {
          classId: null,
          startTime: null,
          endTime: null,
        },
        showDetail: false,
        detailTable: {
          // 表格配置
          url: '/school/report/getRoomStudentReportDetail',
          where: { roomId: '', classId: null, startTime: null, endTime: null },
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            res.count = res.data.total;
            res.data = res.data.records;
            return res;
          },
        },
      };
    },
    created() {
      this.setSelectTime();
      this.queryClass();
    },
    methods: {
      // 获取班级树
      queryClass() {
        this.loading = true;
        finiteDataTree()
          .then((res) => {
            this.loading = false;
            if (res.data.resCode == 200) {
              this.deptData = res.data.data;
              this.dataIdArr = this.$util.getTreeFloor(this.deptData, 1, this.dataIdArr, 'id');
            } else {
              this.$message.error(res.data.data.resMsg || '获取数据失败');
            }
          })
          .catch((e) => {
            this.loading = false;
            this.$message.error(e.message);
          });
      },
      // 选择班级并获取宿舍量化数据
      chooseClass(row) {
        if (row.orgType === 4) {
          this.$refs.orgTree.setCurrentKey(row.id);
          this.classId = row.id.slice(1);
          this.getDorData();
        }
      },
      // 获取宿舍量化数据
      getDorData() {
        this.where = {
          classId: this.classId,
          startTime: this.date[0],
          endTime: this.date[1],
        };
        getDormitoryScoreList(this.where).then((res) => {
          if (res.data.resCode == 200) {
            this.dorData = res.data.data.list;
            this.scoreTotal = res.data.data.totalScore;
          }
        });
      },
      // 查询
      searchData() {
        if (this.where.classId == null && this.where.classId == undefined) return this.$message.error('请选择班级！');
        this.where.startTime = this.date[0];
        this.where.endTime = this.date[1];
        this.getDorData();
      },
      // 默认本月日期
      setSelectTime() {
        var _this = this;
        var date = new Date();
        var y = date.getFullYear();
        var m = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
        var d = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();

        var start_month = y + '-' + '01'; //开始月份：本年第一月份
        var end_month = `${y}-${m}`; //结束月份： 本年当前月份

        var start_day = y + '-' + m + '-' + '01'; //开始日期： 本月第一天
        var end_day = `${y}-${m}-${d}`; //结束日期： 本月今天

        _this.aa = [start_month, end_month]; //默认月份区间
        _this.date = [start_day, end_day]; //默认日期区间  页面显示的
        this.where.startTime = start_day; // 传入后台的 开始时间
        this.where.endTime = end_day; // 传入后台的 结束时间
      },
      // 导出
      exportData() {
        let data = {
          startTime: this.where.startTime,
          endTime: this.where.endTime,
          classId: this.classId,
        };
        dormitoryScoreExport(data).then((res) => {
          let blob = new Blob([res.data], {
            type: 'application/octet-stream',
          });
          let objectUrl = URL.createObjectURL(blob);
          // console.log(objectUrl)
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = objectUrl;
          let filename = window.decodeURI(res.headers['content-disposition'].split('=')[1], 'UTF-8');
          // console.log(res.headers)
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          // console.log(link);
          link.click();
          document.body.removeChild(link); // 下载完成移除元素
          window.URL.revokeObjectURL(objectUrl); // 释放掉blob对象
        });
      },
      getDetail(row) {
        console.log(row);
        this.showDetail = true;
        this.detailTable.where = {
          roomId: row.rommId,
          classId: this.where.classId,
          startTime: this.where.startTime,
          endTime: this.where.endTime,
        }
        this.$refs.detailTable.doLayout();
        this.$refs.detailTable.reload();
      },
    },
  };
</script>

<style scoped>
  .org-tree-group {
    border: 1px solid hsla(0, 0%, 60%, 0.15);
    height: calc(100vh - 150px);
    box-sizing: border-box;
    overflow-x: auto;
  }

  .org-tree-group >>> .el-tree-node__content {
    height: 30px;
  }

  .org-tree-group >>> .el-tree-node__content > .el-tree-node__expand-icon {
    margin-left: 10px;
  }
</style>
